import { render, staticRenderFns } from "./TVDevice.vue?vue&type=template&id=2119659e&"
import script from "./TVDevice.vue?vue&type=script&lang=js&"
export * from "./TVDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports